import { FormErrors } from "redux-form";

import { LoginFormData } from "./LoginPageForm";
import { required } from "../../../util/validators";

const validateLoginPageForm = (values: LoginFormData) => {
    const errors: FormErrors<LoginFormData> = {};

    errors.username = required(values.username);
    errors.password = required(values.password);

    return errors;
};

export default validateLoginPageForm;



// WEBPACK FOOTER //
// ./src/views/login/components/LoginPageFormValidator.ts